/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ terms: NonNullable<unknown>, privacy: NonNullable<unknown> }} Login_Consent_HtmlInputs */



/**
* | output |
* | --- |
* | "I agree to the {terms} and {privacy}. I am 16 or older, or a parent or guardian consenting on behalf of a younger player." |
*
* @param {Login_Consent_HtmlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_consent_html = /** @type {((inputs: Login_Consent_HtmlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Consent_HtmlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`J'accepte les ${i?.terms} et la ${i?.privacy}. J'ai 16 ans ou plus, ou je suis un parent ou tuteur légal donnant mon accord au nom d'un joueur mineur.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Acepto los ${i?.terms} y la ${i?.privacy}. Tengo 16 años o más, o soy padre, madre o tutor/a que consiente en nombre de un jugador menor.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Concordo com os ${i?.terms} e a ${i?.privacy}. Tenho 16 anos ou mais, ou sou pai, mãe ou responsável legal dando consentimento em nome de um jogador menor.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Accetto i ${i?.terms} e la ${i?.privacy}. Ho 16 anni o più, oppure sono un genitore o tutore legale che dà il consenso per conto di un giocatore minorenne.`)
	return /** @type {LocalizedString} */ (`I agree to the ${i?.terms} and ${i?.privacy}. I am 16 or older, or a parent or guardian consenting on behalf of a younger player.`)
});